// Re-export from the new auth location for backward compatibility
export { useAuth } from "@/hooks/domains/auth/useAuth";
import type { AuthMode, AuthRequirementMode } from "@/hooks/auth/types";

export { type AuthMode, type AuthRequirementMode };
